<div class="header">
  <div class="container">
    <div class="row align-items-center">
      <div class="zindex-10 text-left" [ngClass]="{'col-3': !isVUMode, 'col-2': isVUMode}">
        <a class="logo-link" (click)="home()">
          <app-logo></app-logo>
        </a>
      </div>
      <div *ngIf="!isVUMode && !isKiosk" class="col d-block d-md-none nav-mobile">
        <div class="mobile-menu">
          <input id="burger" type="checkbox" (click)="changeMobileMenuCheckbox()" [checked]="mobileMenuCheckbox">
          <label for="burger">
            <span></span>
            <span></span>
            <span></span>
          </label>
          <nav>
            <div>
              <ul>
                <li *ngIf="showScheduleMenu">
                  <a *ngIf="!scheduleMenuLink || isVUMode" (click)="mobileGoToDepartureTime()">{{ schedulePlanTitle | translate }}</a>
                  <a *ngIf="scheduleMenuLink && !isVUMode" [attr.href]="scheduleMenuLink" target="_blank">{{ schedulePlanTitle | translate }}</a>
                </li>
                <li *ngIf="showContact">
                  <a (click)="mobileContact()">{{ 'Contact' | translate }}</a>
                </li>
                <li *ngIf="!partner">
                  <a (click)="mobileRegistration()">{{ 'Sign Up' | translate }}</a>
                </li>
                <li *ngIf="partner">
                  <a (click)="mobileShowPartner()">
                    {{ 'Profile' | translate }}
                  </a>
                </li>
                <li *ngIf="partner">
                  <a (click)="goToBookingOverviewClick()">
                    {{ 'Orders' | translate }}
                  </a>
                </li>
                <li *ngIf="partner && showCardTransactions">
                  <a (click)="mobileShowPartnerTransaction()">
                    {{ 'Transactions' | translate }}
                  </a>
                </li>
                <li *ngIf="partner">
                  <a (click)="mobileLogout()">
                    {{ 'Logout' | translate }}
                  </a>
                </li>
                <li>
                  <app-basket-button (click)="changeMobileMenuCheckbox()"></app-basket-button>
                </li>
                <li>
                  <div class="dropdown-divider"></div>
                </li>
                <li *ngIf="availableLangs && availableLangs.length >= 2" class="small-lang-switcher">
                  <img class="small-lang-switcher__small-flag small-flag" src="{{getFlagFilePath(true)}}"
                    alt="{{'Current_LANG' | translate}}">
                  <a class="small-lang-switcher__text" (click)="changeLang()">{{'Current_LANG' | translate}}</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <div class="d-none d-md-block" [ngClass]="{'col-6': !isVUMode, 'col-9': isVUMode}">
        <nav  *ngIf='!isKiosk'  class="navbar-nav mr-auto">
          <ul>
            <li *ngIf="showHome">
              <a (click)="home()">{{ 'Home' | translate }}</a>
            </li>
            <li *ngIf="showHome && (showScheduleMenu || showPartnerInformation || showContact|| showTicketInformation)">
              <a>|</a>
            </li>
            <li *ngIf="showScheduleMenu">
              <a *ngIf="!scheduleMenuLink || isVUMode" (click)="goToDepartureTime()">{{ schedulePlanTitle | translate }}</a>
              <a *ngIf="scheduleMenuLink && !isVUMode" [attr.href]="scheduleMenuLink" target="_blank">{{ schedulePlanTitle | translate }}</a>
            </li>
            <li *ngIf="showScheduleMenu && (showPartnerInformation || showContact|| showTicketInformation)">
              <a>|</a>
            </li>
            <li *ngIf="showPartnerInformation">
              <a>{{ partnerName }}<span *ngIf="partner.accountBalance != null">{{ partnerAmountBalanceText }}</span></a>
            </li>
            <li *ngIf="showVULogout">
              <a>|</a>
            </li>
            <li *ngIf="showVULogout">
              <a (click)="vuLogout()"> {{ 'Logout' | translate }}</a>
            </li>
            <li *ngIf="showContact">
              <a [attr.href]="contactLink" (click)="contact()" target="_blank">{{ 'Contact' | translate }}</a>
            </li>
            <li *ngIf="showTicketInformation">
              <a (click)="ticketInformation()">{{ 'Ticket information' | translate }}</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="d-none d-md-block header-controls" [ngClass]="{'col-3': !isVUMode, 'col-1': isVUMode}">
        <div class="partner-settings">
          <div *ngIf="!partner && !isVUMode && !isKiosk" class="partner-registration header__partner-registration">
            <a *ngIf="allowedRegistration" class="partner-name d-none d-xga-block" (click)="registration()">{{ 'Sign Up' | translate }}</a>
            <a *ngIf="allowedRegistration" class="partner-name d-block d-xga-none" (click)="registration()">
              <div class="svg-container" [inlineSVG]="'assets/svg/icon/sign-in-alt-solid.svg'"></div>
            </a>
            <a *ngIf="!allowedRegistration" class="partner-name d-none d-xga-block" (click)="login()">{{ 'Sign In' | translate }}</a>
            <a *ngIf="!allowedRegistration" class="partner-name d-block d-xga-none" (click)="login()"><div class="svg-container" [inlineSVG]="'assets/svg/icon/sign-in-alt-solid.svg'"></div></a>
          </div>
          <div *ngIf="partner && !isVUMode && !isKiosk" class="partner-profile header__partner-profile dropdown">
            <a class="dropdown-toggle partner-name d-none d-xga-block" id="navbarDropdown" role="button" aria-haspopup="true"
              data-toggle="dropdown" aria-expanded="false" (click)="onClickPartnerMenu()">
              {{ partner.firstName }}<span *ngIf="partner.accountBalance != null">{{ partnerAmountBalanceText }}</span>
            </a>
            <a class="dropdown-toggle partner-name d-block d-xga-none" id="navbarDropdown" role="button" aria-haspopup="true"
              data-toggle="dropdown" aria-expanded="false" (click)="onClickPartnerMenu()"><span name="user" title="{{ partner.firstName }}" [inlineSVG]="'assets/svg/icon/user-edit-solid.svg'"></span>
            </a>
            <ul *ngIf="!isKiosk" [ngClass]="{'show': showPartnerMenu}" class="dropdown-menu m-0" aria-labelledby="navbarDropdown">
              <li>
                <a class="dropdown-item" (click)="showPartner()">
                  {{ 'Profile' | translate }}
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="goToPartnerOrders()">
                  {{ 'Orders' | translate }}
                </a>
              </li>
              <li *ngIf="showCardTransactions">
                <a class="dropdown-item" (click)="goToPartnerTransaction()">
                  {{ 'Transactions' | translate }}
                </a>
              </li>
              <li>
                <a class="dropdown-item" (click)="logout()">
                  {{ 'Logout' | translate }}
                </a>
              </li>
            </ul>
          </div>
          <app-basket-button [showIcon]="true"></app-basket-button>
          <a *ngIf="availableLangs && availableLangs.length >= 2" class="lang-switcher" (click)="changeLang()">
            <img class="flag" [ngClass]="langClassName" src="{{getFlagFilePath(false)}}" alt="{{'Current_LANG' | translate}}">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
